import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useWishlist } from "../context/WishlistContext";
import { useProducts } from "../context/ProductContext";
import ProductCard from "../components/ProductCard";
import AccountDetailsPopup from "../components/AccountDetailsPopup";

const WishlistPage = () => {
  const { wishlist, loading, clearWishlist } = useWishlist();
  const { products } = useProducts();
  const [showAccountPopup, setShowAccountPopup] = useState(false);

  const wishlistProducts = products.filter((p) => wishlist.includes(p.id));

  const handleWhatsAppClick = (product, variant, quantity) => {
    const accountDetails = localStorage.getItem("accountDetails");
    if (!accountDetails) {
      setShowAccountPopup(true);
      return;
    }

    const account = JSON.parse(accountDetails);
    const qty = quantity > 0 ? quantity : 1;
    const totalPrice = variant.offerPrice * qty;

    let message = `🛒 *NEW ORDER REQUEST*\n\n`;
    message += `📦 *Product Details:*\n`;
    message += `─────────────────\n`;
    message += `${product.name}\n`;
    message += `📏 Size: ${variant.size}\n`;
    message += `🔢 Quantity: ${qty}\n`;
    message += `💰 Price per unit: ₹${variant.offerPrice}\n`;
    message += `─────────────────\n`;
    message += `💵 *Total: ₹${totalPrice}*\n\n`;

    message += `📍 *Delivery Details:*\n`;
    message += `─────────────────\n`;
    message += `👤 Name: ${account.name || "N/A"}\n`;
    message += `📱 Mobile: ${account.mobile}\n`;
    message += `📧 Email: ${account.email || "N/A"}\n`;
    message += `🏠 Address:\n`;
    message += `   ${account.addressLine1}\n`;
    if (account.addressLine2) message += `   ${account.addressLine2}\n`;
    if (account.addressLine3) message += `   ${account.addressLine3}\n`;
    message += `   ${account.city}, ${account.state} - ${account.pincode}\n\n`;
    message += `*Additional shipping charges applicable.*\n`;

    const whatsappUrl = `https://wa.me/919840453354?text=${encodeURIComponent(
      message,
    )}`;
    window.open(whatsappUrl, "_blank");
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <div className="text-6xl mb-4">⏳</div>
          <p className="text-xl text-gray-600">Loading your wishlist...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <div className="max-w-7xl mx-auto px-4">
        <div className="mb-8">
          <h1 className="text-4xl font-bold text-gray-800 mb-2">
            ❤️ My Wishlist
          </h1>
          <p className="text-gray-600">Saved in your browser</p>
        </div>

        {wishlistProducts.length > 0 ? (
          <>
            <div className="flex justify-between items-center mb-6">
              <p className="text-gray-600">
                {wishlistProducts.length}{" "}
                {wishlistProducts.length === 1 ? "item" : "items"} in your
                wishlist
              </p>
              <button
                onClick={clearWishlist}
                className="text-red-600 hover:text-red-700 font-medium"
              >
                Clear All
              </button>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
              {wishlistProducts.map((product) => (
                <ProductCard
                  key={product.id}
                  product={product}
                  onWhatsAppClick={handleWhatsAppClick}
                />
              ))}
            </div>
          </>
        ) : (
          <div className="text-center py-16">
            <div className="text-8xl mb-6">💔</div>
            <h2 className="text-2xl font-bold text-gray-800 mb-4">
              Your wishlist is empty
            </h2>
            <p className="text-gray-600 mb-8">
              Start adding products you love to your wishlist!
            </p>
            <Link
              to="/"
              className="inline-block bg-green-500 text-white px-8 py-3 rounded-lg hover:bg-green-600 font-semibold"
            >
              Browse Products
            </Link>
          </div>
        )}
      </div>
      <AccountDetailsPopup
        isOpen={showAccountPopup}
        onClose={() => setShowAccountPopup(false)}
      />
    </div>
  );
};

export default WishlistPage;
